var refinement = require('./refinement');
var Number = require('./Number');

module.exports = refinement(Number, function (x) { return x % 1 === 0; }, 'Integer');



//////////////////
// WEBPACK FOOTER
// ./~/tcomb/lib/Integer.js
// module id = 738
// module chunks = 114276838955818